import { validateDiscoveryButtons } from './discoveryButtonsValidation';
import { resolveExportImageUrls } from './botBucketImageUrls';
import { badgeIconFromFlags } from './badgeIcon';

const EXCLUDED_KEYS = new Set([
  'botUrl',
  'isDesignPreview',
  'baseApiUrl',
  'botApi',
  'authInPopup',
  'autoLogin',
  'nonAuthTextAdmin',
  'botsList',
  'bots',
  'loadLastSession',
  'showHeaderIcons',
  'defaultBot',
  'urlClickText',
  'headerBadgeIconUrl',
  'pedagogical',
  'botType',
  'regulatoryBotIcon',
  'pedagogyBotIcon',
  'translationFile',
  'botsListUrl',
  'skillLmProjects',
  'urlPath',
  'configUrl',
]);

export function parseDiscoveryJson(discoveryJson, texts = {}) {
  if (discoveryJson == null) {
    return { ok: true, value: null };
  }

  try {
    const parsed = JSON.parse(discoveryJson || '[]');
    if (!Array.isArray(parsed)) {
      return { ok: false, error: texts.jsonMustBeArray };
    }
    return validateDiscoveryButtons(parsed, texts);
  } catch {
    return { ok: false, error: texts.invalidJson };
  }
}

export function buildAdminPayload(draft) {
  if (!draft || typeof draft !== 'object') {
    return {};
  }

  const working = JSON.parse(JSON.stringify(draft));
  delete working.botUrl;
  delete working.isDesignPreview;

  const payload = {};
  Object.entries(working).forEach(([key, value]) => {
    if (!EXCLUDED_KEYS.has(key)) {
      payload[key] = value;
    }
  });

  const icon = badgeIconFromFlags(draft);
  if (icon) {
    payload.icon = icon;
  } else {
    delete payload.icon;
  }
  if (draft?.approvedByPmr === true) {
    payload.approvedByPmr = true;
  } else {
    delete payload.approvedByPmr;
  }
  if (!payload.subjectIconUrl) {
    delete payload.subjectIconUrl;
  }

  return payload;
}

export function buildExportPayload(draft, { botName, domainName }) {
  const payload = buildAdminPayload(draft);
  delete payload.domain;
  if (botName) {
    payload.key = botName;
  }
  return resolveExportImageUrls(payload, { botName, domainName, draft });
}
